<template>
  <div class="flex flex-col items-center justify-center w-full h-full p-8 text-center">
    <h1
      class="font-sans text-3xl font-bold! tracking-tight text-nera-text-accent-dark opacity-0 translate-y-2.5 animate-fade-up">
      {{ currentMessage }}
    </h1>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useAuthStore } from '../stores/auth'

const authStore = useAuthStore();
const userName = authStore.user?.first_name || null;
const currentMessage = ref('');

const genericMessages = [
  "Ready to analyze.",
  "Standing by.",
  "Hello.",
  "Ready.",
  "How can I help?",
  "What's the plan?",
];

const personalizedTemplates = [
  "Ready, {name}.",
  "Hello {name}.",
  "{name}, what's next?",
  "Welcome, {name}.",
  "Hey {name}."
];

const getWelcomeMessage = (username = null) => {
  let options = [];

  if (username) {
    const filledTemplates = personalizedTemplates.map(msg =>
      msg.replace("{name}", username)
    );
    options = [...genericMessages, ...filledTemplates];
  } else {
    options = genericMessages;
  }
  const randomIndex = Math.floor(Math.random() * options.length);
  return options[randomIndex];
}

onMounted(() => {
  currentMessage.value = getWelcomeMessage(userName);
});
</script>
